import { render } from "./EmployeeMonthlySalary.vue?vue&type=template&id=140c8c22&scoped=true"
import script from "./EmployeeMonthlySalary.vue?vue&type=script&lang=js"
export * from "./EmployeeMonthlySalary.vue?vue&type=script&lang=js"

import "./EmployeeMonthlySalary.vue?vue&type=style&index=0&id=140c8c22&lang=scss&scoped=true"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140c8c22"]])

export default __exports__